import styled from "styled-components";

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: ${(props) => props.theme.colors.white};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => props.theme.spacing?.xxl ?? "24px"};
  padding-bottom: ${(props) => props.theme.spacing?.xl ?? "20px"};
  flex-shrink: 0;
`;

export const Title = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing?.sm ?? "8px"};
  overflow-x: hidden;
  overflow-y: visible;
`;

export const TitleTooltipTrigger = styled.span`
  display: inline-flex;
  min-width: 0;
  flex: 1;
`;

export const TitleClickable = styled.span`
  cursor: pointer;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  text-overflow: ellipsis;
  line-height: 1.5;
`;

export const TitleEditWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: block;
  overflow-x: hidden;
  overflow-y: visible;
  line-height: 1.5;
`;

export const TitleInput = styled.input`
  font-size: 20px;
  font-weight: 700;
  line-height: 1.5;
  color: ${(props) => props.theme.colors.neutralBlack || "#000000"};
  border: none;
  background: transparent;
  outline: none;
  padding: 0;
  margin: 0;
  width: 100%;
  min-width: 0;
  vertical-align: baseline;
`;

export const HeaderActions = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing?.lg ?? '16px'}; /* 4x (4 × 4px base) */
`;

export const HeaderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s ease;
  padding: 0;

  &:hover {
    background: ${(props) => props.theme.colors.backgroundSecondary || 'rgba(0, 0, 0, 0.05)'};
  }

  &:active {
    background: ${(props) => props.theme.colors.background || 'rgba(0, 0, 0, 0.1)'};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.primary || '#4F46E5'};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const HeaderMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;

  button {
    width: 32px;
    height: 32px;
    min-width: 32px;
    padding: 0;
    border-radius: 6px;
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 ${(props) => props.theme.spacing?.xxl ?? "24px"};
`;

export const EditorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;

  .editor-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    container-type: inline-size;
    container-name: editor-toolbar;
  }

  .editor-inner {
    flex: 1;
    overflow: auto;
    padding: ${(props) => props.theme.spacing?.lg ?? "16px"} 0 ${(props) => props.theme.spacing?.xxl ?? "24px"};
  }

  .editor-input {
    min-height: 180px;
  }
`;

/** Blur overlay + circular loading while AI rewrite (improve, fix grammar, etc.) is in progress. */
export const LoadingBlurBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 2;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;
